<div
  appCoordinatePicker
  [enable]="widget !== undefined && widget.pickerCommandId !== undefined"
  [animation]="widget?.pickerAnimation"
  (coordinates)="coordinatesPicked($event)"
  class="picking-container"
>
  <ng-content></ng-content>
</div>
